<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="qrCode">

      <!-- <div class="main-content"> -->
        <!-- title and content -->
        <div class="page-width pre-formatted padding">
          <h2>Download the Elegant Granite App!</h2>
          <p>Take your shopping to-go with the Elegant Granite app on iOS and Android.</p>
          <div class="image-holder">
            <img src="../../assets/img/app_ios.png"/>
          </div>
          <!-- <div class="section-header text-center">
            <h2>{{ $t('companyInformationTitle') }}</h2>
          </div>
          <p v-html="$t('companyInformationBody')"></p>
          </br>
          </br>
          <p>Address: 6201 Coliseum Way Suite A&B, Oakland, CA 94621</p>
        </div> -->
        <!-- image -->

        <!-- <div class="pre-formatted">
          <ul>
            <li>
              <img src="../../assets/img/warehouse1.png" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/warehouse2.png" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/warehouse3.png" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/warehouse4.png" alt=""/>
            </li>
          </ul>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';

export default {
  name: "qrCode",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: 'QR Code',
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/about.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/qrCode.vue